import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  Grid,
  Button,
  Select,
  Divider,
  TextField,
  InputLabel,
  Typography,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormHelperText,
  MenuItem,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { CheckBoxOutlineBlank, CheckBox } from "@material-ui/icons";
import dayjs from "dayjs";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";

import MultiFileManager from "../../File/MultiFileManager/MultiFileManager";
import DuplicateCheckModal from "../../../components/Achievement/DuplicateCheckModal";

import { uploadMultiFile } from "../../../reducer/file/action";
import { insertAchievement, updateAchievement, checkDuplicateAchievement } from "../../../reducer/achievement/action";
import { statisticUnaccepted } from "../../../reducer/profile/action";
import { getAllEmploymentContractByProfileId } from "../../../reducer/employmentContract/action";
import { notification } from "../../../reducer/home/action";

import EmploymentContractTable from "../../../components/EmployContractModal/EmploymentContractTable";
import EmploymentContractDetailTable from "../../../components/EmployContractModal/EmploymentContractDetailTable";
import { getCurrentSchoolYear } from "containers/User/TimeResearch/utils";
import { ACHIEVEMENT } from "../../../constants/selectOptions";

function AchievementInsertModal(props) {
  const { inserting, setInserting } = props;

  const currentYear = getCurrentSchoolYear();
  const [values, setValues] = useState({
    purposeId: 5,
    departmentId: props.profileDepartments?.[0]?.id || null,
  });
  const [detail, setDetail] = useState(null);
  const [profileList, setProfileList] = useState([]);
  const [newFiles, setNewFiles] = useState([]);
  const [helperText, setHelperText] = useState(false);
  const [duplicateModalOpen, setDuplicateModalOpen] = useState(false);
  const [duplicateList, setDuplicateList] = useState([]);
  const [pendingSubmit, setPendingSubmit] = useState(false);

  const profileListFromProps = props.profileList;
  const contractList = props.employmentContractListById;

  // Tự gán bản thân vào danh sách tác giả
  React.useEffect(() => {
    if (props.profile?.id && profileList.length === 0) {
      setProfileList([
        {
          profileId: props.profile.id,
          roleInAchievement: "main",
          isInternal: true,
          externalName: "",
          timeAmount: null,
        },
      ]);
    }
  }, [inserting, props.profile?.id]);

  useEffect(() => {
    const contract = props?.employmentContractListById?.find(
      (e) => e?.contract?.id === values?.contractIdForKpi,
    )?.contract;
    setDetail(contract?.listKpi?.find((e) => e.id === values.kpiIdForKpi));
  }, [props?.employmentContractListById, values?.contractIdForKpi]);

  const handleChangeForm = (name, value) => {
    setValues({ ...values, [name]: value });
  };

  const handleChangeProfileList = (index, name, value) => {
    const temp = profileList;
    const tempElm = profileList[index];
    temp.splice(index, 1, { ...tempElm, [name]: value });
    setProfileList([...temp]);
  };

  const handleInsert = () => {
    const temp = profileList;
    temp.push({
      profileId: null,
      roleInAchievement: "member",
      isInternal: true,
      externalName: "",
      timeAmount: null,
    });
    setProfileList([...temp]);
  };

  const handleRemove = (index) => {
    const temp = profileList;
    temp.splice(index, 1);
    setProfileList([...temp]);
  };

  const checkForDuplicates = async (title) => {
    if (!title || title.trim() === "") return false;

    const result = await props.checkDuplicateAchievement({
      publicationType: "achievements",
      title: title.trim(),
    });

    if (result.success && result.data && result.data.length > 0) {
      setDuplicateList(result.data);
      setDuplicateModalOpen(true);
      return true;
    }
    return false;
  };

  const handleSelectDuplicate = (selectedAchievement) => {
    setDuplicateModalOpen(false);
    setInserting(false);
    if (props.setUpdating) {
      props.setUpdating({ ...selectedAchievement, _fromDuplicate: true });
    }
  };

  const handleCloseDuplicateModal = () => {
    setDuplicateModalOpen(false);
    setPendingSubmit(true);
  };

  const proceedWithSubmit = () => {
    insertAchievementItem().then((success) => {
      if (success) {
        props.statisticUnaccepted({
          departmentId: 0,
          profileId: props.profile?.id,
        });
        if (props.role === "sudo-admin") props.statisticUnaccepted({ departmentId: 0, profileId: 0 });
      }
    });

    setValues({ purposeId: 5 });
    setProfileList([]);
    setNewFiles([]);
    setInserting(false);
    setHelperText(false);
    setPendingSubmit(false);
  };

  React.useEffect(() => {
    if (pendingSubmit) {
      proceedWithSubmit();
    }
  }, [pendingSubmit]);

  const insertAchievementItem = async () => {
    let result = await props
      .insertAchievement(props.profile?.id, {
        ...values,
        achievementProfile: profileList,
      })
      .then(async (response) => {
        if (response.success && newFiles.length !== 0) {
          const uploadResult = await props.uploadMultiFile(response.data.id, newFiles, "achievement");
          if (uploadResult.success)
            props.updateAchievement(response.data.id, {
              ...response.data,
              fileUrl: uploadResult.data.join("||"),
            });
        }
        if (response.success) {
          props.statisticUnaccepted({
            departmentId: 0,
            profileId: props.profile?.id,
          });
          if (props.role === "sudo-admin") props.statisticUnaccepted({ departmentId: 0, profileId: 0 });
        }
        return response.success;
      });
    return result;
  };

  const handleSubmit = async (e) => {
    // Check required fields
    if (
      //   !values?.awardCode ||
      !values?.awardType ||
      !values?.awardedProjectName ||
      !values?.numOfAuthors ||
      newFiles.length === 0
    ) {
      setHelperText(true);
      return;
    }

    // Validate profileList for external members
    const hasEmptyExternalName = profileList.some((e) => !e.isInternal && e.externalName === "");
    if (hasEmptyExternalName) {
      setHelperText(true);
      return;
    }

    // Validate at least one internal member
    const hasInternalMember = profileList.some((e) => e.isInternal === true);
    if (!hasInternalMember) {
      props.pushNoti({
        type: "warning",
        message: "Phải có ít nhất 1 thành viên nội bộ của trường trong công trình khoa học!",
      });
      return;
    }

    // Validate purposeId = 1 requires profileIdForKpi
    if (values?.purposeId === 1 && !values?.profileIdForKpi) {
      setHelperText(true);
      return;
    }

    // Check for duplicates
    const hasDuplicates = await checkForDuplicates(values?.awardedProjectName);
    if (hasDuplicates) {
      return;
    }

    insertAchievementItem().then((success) => {
      if (success) {
        props.statisticUnaccepted({
          departmentId: 0,
          profileId: props.profile?.id,
        });
        if (props.role === "sudo-admin") props.statisticUnaccepted({ departmentId: 0, profileId: 0 });
      }
    });

    setValues({ purposeId: 5 });
    setProfileList([]);
    setNewFiles([]);
    setInserting(false);
    setHelperText(false);
  };

  const handleCloseInsertModal = () => {
    setDuplicateModalOpen(false);
    setDuplicateList([]);
    setPendingSubmit(false);
    setValues({
      purposeId: 5,
      departmentId: props.profileDepartments?.[0]?.id || null,
    });
    setDetail(null);
    setProfileList([]);
    setNewFiles([]);
    setHelperText(false);
    setInserting(false);
  };

  return (
    <Dialog fullWidth keepMounted maxWidth="lg" open={inserting} onClose={handleCloseInsertModal} disableBackdropClick>
      <DialogTitle>Thêm giải thưởng</DialogTitle>
      <DialogContent style={{ display: "flex", gap: 16, overflowX: "hidden" }}>
        <div style={{ flex: "1 1 auto", minWidth: 0, paddingRight: 16 }}>
          <Grid container justifyContent="flex-start" spacing={2} style={{ marginBottom: 10 }}>
            {/* <Grid item xs={4}>
            <TextField
              fullWidth
              size="small"
              label="Mã giải thưởng"
              variant="outlined"
              value={values?.awardCode?.toString() || ""}
              required
              error={helperText && !values?.awardCode}
              helperText={helperText && !values?.awardCode ? "Vui lòng nhập mã giải thưởng" : ""}
              onChange={(event) => handleChangeForm("awardCode", event.target.value)}
            />
          </Grid> */}
            <Grid item xs={6}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                label="Mã CTKH"
                value={values?.hemisCode || ""}
                onChange={(event) => handleChangeForm("hemisCode", event.target.value)}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                select
                fullWidth
                size="small"
                //   label="Loại giải thưởng"
                variant="outlined"
                value={values?.awardType || ""}
                required
                error={helperText && !values?.awardType}
                helperText={helperText && !values?.awardType ? "Vui lòng chọn loại giải thưởng" : ""}
                onChange={(event) => handleChangeForm("awardType", event.target.value)}
                SelectProps={{ native: true }}
              >
                <option value="">-- Chọn loại giải thưởng --</option>
                {ACHIEVEMENT.awardType.map((e) => (
                  <option key={e.key} value={e.value}>
                    {e.title}
                  </option>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                label="Cơ quan tổ chức Giải thưởng"
                variant="outlined"
                value={values?.organizingAgency?.toString() || ""}
                onChange={(event) => handleChangeForm("organizingAgency", event.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                label="Tên đề tài, công trình được trao giải"
                variant="outlined"
                value={values?.awardedProjectName?.toString() || ""}
                required
                error={helperText && !values?.awardedProjectName}
                helperText={
                  helperText && !values?.awardedProjectName ? "Vui lòng nhập tên đề tài, công trình được trao giải" : ""
                }
                onChange={(event) => handleChangeForm("awardedProjectName", event.target.value)}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                size="small"
                label="Tên đơn vị được trao giải"
                variant="outlined"
                value={values?.awardedUnitName?.toString() || ""}
                onChange={(event) => handleChangeForm("awardedUnitName", event.target.value)}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                select
                fullWidth
                size="small"
                //   label="Mức giải thưởng"
                variant="outlined"
                value={values?.awardLevel || ""}
                onChange={(event) => handleChangeForm("awardLevel", event.target.value)}
                SelectProps={{ native: true }}
              >
                <option value="">-- Chọn mức giải thưởng --</option>
                {ACHIEVEMENT.awardLevel.map((e) => (
                  <option key={e.key} value={e.value}>
                    {e.title}
                  </option>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                size="small"
                label="Quyết định cấp bằng khen, giấy khen"
                variant="outlined"
                value={values?.decisionDocument?.toString() || ""}
                onChange={(event) => handleChangeForm("decisionDocument", event.target.value)}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                size="small"
                label="Cơ quan/ tổ chức ban hành quyết định"
                variant="outlined"
                value={values?.issuingAgency?.toString() || ""}
                onChange={(event) => handleChangeForm("issuingAgency", event.target.value)}
              />
            </Grid>
            <Grid item xs={6}>
              <Autocomplete
                fullWidth
                size="small"
                options={(props.departmentList || []).filter((d) => d.id !== 0)}
                getOptionLabel={(option) => option?.name || ""}
                value={
                  (props.departmentList || []).filter((d) => d.id !== 0).find((d) => d.id === values?.departmentId) ||
                  null
                }
                onChange={(event, newValue) => handleChangeForm("departmentId", newValue?.id)}
                renderInput={(params) => <TextField {...params} size="small" label="Đơn vị" variant="outlined" />}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                size="small"
                type="number"
                variant="outlined"
                label="Số lượng tác giả"
                value={values?.numOfAuthors || ""}
                required
                error={helperText && !values?.numOfAuthors}
                helperText={helperText && !values?.numOfAuthors ? "Vui lòng nhập số lượng tác giả" : ""}
                onChange={(event) => handleChangeForm("numOfAuthors", parseInt(event.target.value))}
              />
            </Grid>
            {/* <Grid item xs={12}>
            <FormControl fullWidth variant="outlined" size="small">
              <InputLabel id="purpose-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                Mục đích
              </InputLabel>
              <Select
                native
                fullWidth
                labelId="purpose-label"
                value={values?.purposeId ?? 5}
                onChange={(event) => handleChangeForm("purposeId", parseInt(event.target.value))}
              >
                {props.purposes.filter(e => e.name !== 'bonusCalculated').map((e) => (
                  <option key={e.id} value={e.id}>
                    {e.description}
                  </option>
                ))}
              </Select>
            </FormControl>
          </Grid> */}

            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                label="Ghi chú"
                variant="outlined"
                value={values?.note || ""}
                multiline
                rows={3}
                onChange={(event) => handleChangeForm("note", event.target.value)}
              />
            </Grid>

            <Grid item xs={5} style={{ margin: "auto" }}>
              <Divider />{" "}
            </Grid>
            <Grid item xs={2}>
              <Typography style={{ textAlign: "center", color: "rgba(0, 0, 0, 0.30)" }}>Thành viên</Typography>
            </Grid>
            <Grid item xs={5} style={{ margin: "auto" }}>
              <Divider />{" "}
            </Grid>

            <Grid item xs={12}>
              {profileList.map((e, index) => (
                <Grid key={`list-${index}`} container spacing={2}>
                  <Grid item xs={1}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={e.isInternal !== false}
                          onChange={(event) => handleChangeProfileList(index, "isInternal", event.target.checked)}
                          color="primary"
                        />
                      }
                      label="Nội bộ"
                    />
                  </Grid>
                  {e.isInternal && (
                    <Grid item xs={values?.purposeId !== 1 ? 5 : 4}>
                      <Autocomplete
                        disableClearable
                        options={props.profileList}
                        getOptionLabel={(option) => option.name}
                        value={profileListFromProps?.find((profile) => profile.id === e.profileId)}
                        onChange={(event, profile) => {
                          if (profileList[index]?.profileId === values?.profileIdForKpi)
                            handleChangeForm("profileIdForKpi", null);
                          handleChangeProfileList(index, "profileId", parseInt(profile?.id));
                        }}
                        renderInput={(params) => (
                          <TextField {...params} size="small" label="Thành viên" variant="outlined" />
                        )}
                      />
                    </Grid>
                  )}
                  {!e.isInternal && (
                    <Grid item xs={values?.purposeId !== 1 ? 5 : 4}>
                      <TextField
                        fullWidth
                        size="small"
                        variant="outlined"
                        label="Tên thành viên"
                        value={e?.externalName || ""}
                        onChange={(event) => handleChangeProfileList(index, "externalName", event.target.value)}
                      />
                      {helperText && e.externalName === "" && (
                        <FormHelperText style={{ color: "red" }}>Không được để trống</FormHelperText>
                      )}
                    </Grid>
                  )}
                  <Grid item xs={values?.purposeId !== 1 ? 5 : 3}>
                    <FormControl fullWidth variant="outlined" size="small">
                      <InputLabel id="roleInAchievement-label" style={{ padding: "0 8px", backgroundColor: "white" }}>
                        Vai trò
                      </InputLabel>
                      <Select
                        native
                        fullWidth
                        labelId="roleInAchievement-label"
                        value={e.roleInAchievement}
                        onChange={(event) => handleChangeProfileList(index, "roleInAchievement", event.target.value)}
                      >
                        {ACHIEVEMENT.roleOptions.map((role) => (
                          <option key={role.key} value={role.value}>
                            {role.title}
                          </option>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  {values?.purposeId === 1 && (
                    <Grid item xs={3}>
                      <FormControl required fullWidth error={!values?.profileIdForKpi}>
                        <Button
                          fullWidth
                          color="primary"
                          variant="outlined"
                          style={{ height: 40 }}
                          disabled={e.profileId === null}
                          startIcon={
                            typeof values?.profileIdForKpi === "number" && values?.profileIdForKpi === e.profileId ? (
                              <CheckBox />
                            ) : (
                              <CheckBoxOutlineBlank />
                            )
                          }
                          onClick={() => {
                            setDetail(null);
                            props.getAllEmploymentContractByProfileId(parseInt(e.profileId));
                            handleChangeForm(
                              "profileIdForKpi",
                              values?.profileIdForKpi !== e.profileId ? parseInt(e.profileId) : null,
                            );
                          }}
                        >
                          Tính KPI
                        </Button>
                        {!values?.profileIdForKpi && <FormHelperText>Phải chọn 1 người tính KPI</FormHelperText>}
                      </FormControl>
                    </Grid>
                  )}
                  <Grid item xs={1}>
                    <Button
                      fullWidth
                      color="secondary"
                      variant="contained"
                      style={{ height: 40 }}
                      onClick={() => handleRemove(index)}
                    >
                      Xoá
                    </Button>
                  </Grid>
                </Grid>
              ))}
            </Grid>

            <Grid item xs={12}>
              <Button fullWidth variant="outlined" onClick={handleInsert}>
                Thêm thành viên
              </Button>
            </Grid>
          </Grid>
          <div
            style={{
              flexDirection: "column",
              display: values?.profileIdForKpi !== null && values?.profileIdForKpi >= 0 ? "block" : "none",
            }}
          >
            <EmploymentContractTable
              contract={detail}
              contractList={contractList}
              kpiIdForKpi={values?.kpiIdForKpi}
              contractIdForKpi={values?.contractIdForKpi}
              setDetail={setDetail}
              values={values}
              setValues={setValues}
              handleChangeForm={handleChangeForm}
            />
            <EmploymentContractDetailTable kpi={detail} />
          </div>
        </div>
        <div style={{ flex: "0 0 380px", paddingLeft: 16, borderLeft: "1px solid #e0e0e0" }}>
          <Typography variant="subtitle2" style={{ marginBottom: 8 }}>
            File minh chứng
          </Typography>
          <MultiFileManager fileUrls={[]} setFileUrls={() => {}} newFiles={newFiles} setNewFiles={setNewFiles} />
        </div>
      </DialogContent>
      <DialogActions style={{ padding: "0 24px 8px 24px" }}>
        <Grid container justifyContent={"space-between"}>
          <div />
          <div style={{ float: "right" }}>
            <Button variant="outlined" color="secondary" onClick={handleCloseInsertModal} style={{ marginRight: 4 }}>
              Huỷ
            </Button>
            <Button variant="contained" color="primary" onClick={() => handleSubmit()}>
              Xác nhận
            </Button>
          </div>
        </Grid>
      </DialogActions>
      <DuplicateCheckModal
        open={duplicateModalOpen}
        handleClose={handleCloseDuplicateModal}
        duplicateList={duplicateList}
        handleSelect={handleSelectDuplicate}
      />
    </Dialog>
  );
}

const mapStateToProps = (state) => ({
  role: select(state, "userReducer", "role"),
  profile: select(state, "profileReducer", "detail"),
  purposes: select(state, "scientificResearchReducer", "purposes"),
  profileList: select(state, "profileReducer", "list"),
  profileDepartments: select(state, "profileReducer", "departments"),
  departmentList: select(state, "departmentReducer", "departments"),
  listById: select(state, "achievementReducer", "listById"),
  employmentContractListById: select(state, "employmentContractReducer", "listById"),
});

const mapDispatchToProps = (dispatch) => ({
  statisticUnaccepted: (payload) => dispatch(statisticUnaccepted(payload)),
  insertAchievement: (profileId, payload) => dispatch(insertAchievement(profileId, payload)),
  uploadMultiFile: (id, files, type) => dispatch(uploadMultiFile(id, files, type)),
  updateAchievement: (id, payload) => dispatch(updateAchievement(id, payload)),
  getAllEmploymentContractByProfileId: (id) => dispatch(getAllEmploymentContractByProfileId(id)),
  checkDuplicateAchievement: (payload) => dispatch(checkDuplicateAchievement(payload)),
  pushNoti: (payload) => dispatch(notification(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(AchievementInsertModal));

